import api from './api';

export const emailService = {
  sendStatusNotification: (data) =>
    api.post('/email/gui-thong-bao-trang-thai', data),

  sendHiredEmail: (data) =>
    api.post('/email/gui-mail-trung-tuyen', data),

  resetEmailStatus: (data) =>
    api.post('/email/reset-trang-thai-gui-email', data),

  resetHiredEmailStatus: (data) =>
    api.post('/email/reset-trang-thai-gui-email-trung-tuyen', data),

  sendFailedInterviewEmail: (data) =>
    api.post('/email/gui-mail-rot-phong-van', data),

  resetFailedInterviewEmailStatus: (data) =>
    api.post('/email/reset-trang-thai-gui-email-rot-phong-van', data),
};

export default emailService;
